// The leave guard's registry (spec/dashboard.md section 4.6): every place that holds unsaved work registers a dirty-checker,
// and <LeaveGuard /> asks the browser to confirm a reload, a tab close or an external navigation while any of them is dirty.
const sources = new Map<string, () => boolean>();

/** Registers (or replaces) the dirty-checker `id`; returns its unregister. */
export function registerDirtySource(id: string, isDirty: () => boolean): () => void {
  sources.set(id, isDirty);
  return () => {
    if (sources.get(id) === isDirty) sources.delete(id);
  };
}

/** True while any registered source holds unsaved work (a throwing checker counts as clean). */
export function anyDirty(): boolean {
  for (const isDirty of sources.values()) {
    try {
      if (isDirty()) return true;
    } catch {
      // a broken checker never blocks leaving
    }
  }
  return false;
}
